import moment from 'moment';

export const freezePeriods = [
  { start: moment('2024-04-23'), end: moment('2024-05-06') },
  { start: moment('2024-07-22'), end: moment('2024-08-06') },
  { start: moment('2024-10-24'), end: moment('2024-11-06') },
  { start: moment('2025-01-24'), end: moment('2025-02-06') },
  { start: moment('2025-04-23'), end: moment('2025-05-06') },
  { start: moment('2025-07-24'), end: moment('2025-08-06') },
  { start: moment('2025-10-24'), end: moment('2025-11-06') },
  { start: moment('2026-01-26'), end: moment('2026-02-05') },
];
